// Public portal copy and presentation constants.
// Deployment-specific wording lives here (one place) so another Studio can replace it
// without touching components. Copy must stay outcome-led: no infrastructure vocabulary.

// The unmodified platform mark; it is shown on a light plate, never recolored or redrawn.
export const PLATFORM_LOGO = "/HACaMS%20LogoTM.png";
export const DEFAULT_WORDMARK = "/brand/pilates-deluxe-wordmark-light.png";

export const JOIN_LABEL = "Join the family";
export const LOGIN_LABEL = "Member sign in";

export const DOOR = {
  line: "Enter here for a world of stillness, strength and light",
  hint: "Open the door",
};

export const WELCOME = {
  kicker: "Welcome",
  title: ["You've stepped in.", "Stay a while."],
  body: "A studio designed to slow you down, strengthen you from the core and send you home lighter.",
};

export const PRACTICE = {
  title: "The practice",
  items: [
    { id: "reformer", numeral: "01", title: "Strength, with support", body: "Precision work on the reformer, guided in small groups." },
    { id: "mat", numeral: "02", title: "Flow, on your own ground", body: "Classic mat Pilates that builds control, balance and ease." },
    { id: "private", numeral: "03", title: "Just you, fully attended", body: "One-to-one sessions shaped around your body and goals." },
  ],
};

// Each phase drives the room illustration. `music` is none | welcome | class | cooldown.
export const SCENE = {
  kicker: "The studio that responds to you",
  title: ["It prepares itself,", "so you can simply arrive."],
  phases: [
    { id: "prepare", clock: "6:25", label: "Before you arrive", lights: 0.6, music: "none", falters: false, body: "Five minutes before class, the lights warm up on their own." },
    { id: "begin", clock: "6:30", label: "Class begins", lights: 1, music: "class", falters: false, body: "The room settles into your class. Ambient music gives way to your playlist." },
    { id: "falter", clock: "6:41", label: "Even if something falters", lights: 1, music: "class", falters: true, body: "If one thing pauses, the studio contains it and your class carries on." },
    { id: "cooldown", clock: "7:25", label: "Afterglow", lights: 0.35, music: "cooldown", falters: false, body: "Cooldown music, then quiet. The room resets for whoever is next." },
  ],
};

// Only capabilities that are accepted may be presented as available.
// Anything else must carry an honest status label.
export const BEYOND = {
  title: "Beyond the room",
  items: [
    { id: "updates", status: "in-progress", title: "Class updates on your phone", body: "Timely notes about your classes, only the ones meant for you." },
    { id: "checkin", status: "coming-soon", title: "Easy check-in and booking", body: "Arrive, tap, and you're in." },
  ],
};
export const STATUS_LABELS = { "in-progress": "In progress", "coming-soon": "Coming soon" };

export const LOOK_INSIDE = {
  kicker: "A look inside",
  title: "Explore every room, once you're in.",
  body: "Members get the full studio map, with what each space offers, matched to their access.",
  lock: "Members step inside to explore",
};

export const JOIN = {
  kicker: JOIN_LABEL,
  title: ["Come as you are.", "Leave a little lighter."],
  submit: "Request access",
  note: "Access is enabled after the Studio team reviews your request.",
};

// Decorative, illustrative plan: normalized percentages, not live data and not to scale.
export const ILLUSTRATIVE_PLAN = [
  { id: "reception", left: 0, top: 0, width: 19.65, height: 82.84 },
  { id: "group", left: 19.65, top: 28.36, width: 56.4, height: 70.52, hero: true },
  { id: "r1", left: 48.24, top: 0, width: 6.62, height: 26.87 },
  { id: "r2", left: 54.85, top: 0, width: 7.95, height: 26.87 },
  { id: "r3", left: 62.81, top: 0, width: 6.62, height: 28.36 },
  { id: "r4", left: 69.43, top: 0, width: 6.62, height: 28.36 },
  { id: "private", left: 76.05, top: 0, width: 23.95, height: 100 },
];
